import * as React from 'react';
import { IStackStyles, DefaultButton, IIconProps, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import './OrderHistory.scss';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import Header from '../../../common/Header';
import { IOrderHistoryProps, IOrderHistoryState, IOrderHistory } from '../../../../interfaces/IOrderHistory';
import { _getOrderHistory } from '../../../../services/orderhistory.service';
import { ProgressStatus } from '../../../../constants/GlobalConstants';
import Loader from '../../../common/loader/Loader';
import { _getInputService } from '../../../../services/event.service';
import { IEvent } from '../../../../interfaces/IEvent';
import history from '../../../../lib/history';

const PDFIcon: IIconProps = { iconName: 'PDF', className: 'text-danger ms-fontSize-24' };

export default class OrderHistory extends React.Component<IOrderHistoryProps, IOrderHistoryState> {

  constructor(props: IOrderHistoryProps) {
    super(props);
    this.state = {
      ProgressStatus: ProgressStatus.Init,
      columns: this.getColumns(),
      isCompactMode: false,
      SelectedEvent: "",
      Events: [],
      OrderHistory: [],
      FilterOrderHistory: [],
      EventOptions: []
    };
  }

  componentDidMount() {
    this.getEvent();
    this.getOrderHistory();
  }

  private getColumns(): IColumn[] {
    const columns: IColumn[] = [
      {
        key: 'column',
        name: 'Action',
        className: classNames.fileIconCell,
        iconClassName: classNames.fileIconHeaderIcon,
        iconName: 'Remove',
        isIconOnly: true,
        fieldName: 'name',
        minWidth: 16,
        maxWidth: 16,
        onRender: (orderHistory: IOrderHistory) => {
          const created = orderHistory.Created ? new Date(orderHistory.Created) : undefined;
          const createdText = created ? `${created.toLocaleDateString("NL-nl")} ${created.getHours()}:${created.getMinutes()}` : "";

          return <div>
            <h6 className="mb-0">{orderHistory.OrderNumber}</h6>
            <div className="row">
              <div className="col-6">
                <span>Aangemaakt op</span>
              </div>
              <div className="col-6">
                <span>{createdText}</span>
              </div>
              
              <div className="col-6">
                <span>Event</span>
              </div>
              <div className="col-6">
                <span>{orderHistory.EventName}</span>
              </div>
              
              <div className="col-6">
                <span>Locatie</span>
              </div>
              <div className="col-6">
                <span>{orderHistory.Location}</span>
              </div>
              
              <div className="col-6">
                <span>Deelnemer</span>
              </div>
              <div className="col-6">
                <span>{orderHistory.Participant}</span>
              </div>

              <div className="col-6">
                <span>Manager</span>
              </div>
              <div className="col-6">
                <span>{orderHistory.EventManager}</span>
              </div>

              <div className="col-6">
                <span>Status</span>
              </div>
              <div className="col-6">
                <span>{orderHistory.OrderStatus ? "Goedgekeud" : "Verzonden"}</span>
              </div>

              {
                orderHistory && orderHistory.PDF &&
                <div className="col-12 mt-2">
                  <DefaultButton className="download-btn-block p-3 ms-fontSize-18" iconProps={PDFIcon} text="Download PDF" allowDisabledFocus
                    onClick={() => window.open(orderHistory.PDF, "_blank")}
                  />
                </div>
              }
            </div>
          </div>;

        }
      }
    ];
    return columns;
  }

  private getOrderHistory(): IOrderHistory[] {
    this.setState({ ProgressStatus: ProgressStatus.Loading });
    let bodyData = {
      "Technicus_UPN": ""
    };
    let items: IOrderHistory[] = [];
    _getOrderHistory(bodyData).then((res: any) => {
      if (res.Meerwerkbonnen != null && res.Meerwerkbonnen.length > 0) {
        const meerwerkbonnen: any[] = res.Meerwerkbonnen;

        meerwerkbonnen.forEach((result: any) => {
          var _orderHistory: IOrderHistory = {
            ID: result.ID,
            OrderNumber: result.Bonnummer,
            PDF: result.PDF,
            EventName: result.Beurs,
            Location: result.Locatie,
            Participant: result.Deelnemer,
            EventManager: result.Eventmanager,
            Created: result.Created,
            Icon: result.Akkoord ? "DocumentApproval" : "Send",
            OrderStatus: result.Akkoord
          };
          items.push(_orderHistory);

          // update events with an order
          const eventsWithOrder = [...this.state.Events].filter(e => meerwerkbonnen.find(mb => mb.Beurs === e.Title));
          this.updateEvents(eventsWithOrder);
        });
        this.setState({
          OrderHistory: [...items],
          FilterOrderHistory: [...items]
        });

        this.setState({ ProgressStatus: ProgressStatus.Loaded });
        return items;
      } else {
        this.setState({ ProgressStatus: ProgressStatus.Loaded });
        return [];
      }
    });
    return [];

  }

  private _getKey(item: any, index?: number): string {
    return item.key;
  }

  private _onItemInvoked(item: any): void {
   // alert(`Item invoked: ${item.name}`);
  }

  private onTextChangeEvent = (name: string, value: string, data?: any) => {
    this.setState({ SelectedEvent: value });
    if (value !== "") {

      var _filterOrderHistory = this.state.OrderHistory.filter(function (el: IOrderHistory) {
        return el.EventName === value
      });

      this.setState({
        FilterOrderHistory: _filterOrderHistory
      })
    } else {
      this.setState({
        FilterOrderHistory: [...this.state.OrderHistory]
      });
    }
  }

  private getEvent(): void {
    this.setState({ ProgressStatus: ProgressStatus.Loading });
    _getInputService().then(res => {
      let filterEvents: IEvent[] = res.Events.map(
        (data: any) => {
          return {
            Id: data.Title,
            Title: data.Title
          }
        });

      this.setState({
        Events: filterEvents
      });

      this.updateEvents(filterEvents);
    });
  }

  private updateEvents = (events: IEvent[]) => {
    let filterEvents: IEvent[] = events.map(
      (data: any) => {
        return {
          Id: data.Title,
          Title: data.Title
        }
      });
    let eventOptions: IDropdownOption[] = [];
    filterEvents.forEach(event => {
      eventOptions.push({
        key: event.Id,
        text: event.Title
      })
    });

    // sort events by text
    eventOptions = eventOptions.sort((a, b) => a.text.localeCompare(b.text));
    
    const selectEventOption: IDropdownOption = { key: '', text: 'Selecteer event', data: '' };

    const allOptions = [selectEventOption];
    allOptions.push(...eventOptions);

    this.setState({
      EventOptions: allOptions
    });
  }

  private onHeaderBack = () => {
    history.push("/dashboard");
  }

  stackStyles: Partial<IStackStyles> = { root: {} };

  public render() {
    const { columns, isCompactMode, OrderHistory, FilterOrderHistory } = this.state;

    return (
      this.state.ProgressStatus != ProgressStatus.Loaded ?
        <Loader PageTitle="<b>Meerwerkbon geschiedenis</b> scherm wordt geladen" /> :
        <div className="page">
          <Header isBackVisible={true} _onBack={this.onHeaderBack} />
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-auto">
                <span>Event:</span>
              </div>
              <div className="col-auto bottom-border-input">
                <Dropdown placeholder="Selecteer een event" options={this.state.EventOptions}
                  onChanged={(option: IDropdownOption, index?: number) => {
                    this.onTextChangeEvent("Event", option.key.toString(), option.data)
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-4">
                <DetailsList
                  items={FilterOrderHistory}
                  compact={isCompactMode}
                  columns={columns}
                  selectionMode={SelectionMode.none}
                  getKey={this._getKey}
                  setKey="none"
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={false}
                  onItemInvoked={this._onItemInvoked}
                />
                {
                  this.state.FilterOrderHistory.length === 0 &&
                  <MessageBar messageBarType={MessageBarType.info}>Er zijn geen meerwerkbonnen gevonden voor dit event</MessageBar>
                }
              </div>
            </div>
          </div>
        </div>
    )
  };
}

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: '16px'
  },
  fileIconCell: {
    textAlign: 'left',
    selectors: {
      '&:before': {
        content: '.',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0px',
        visibility: 'hidden'
      }
    }
  },
  fileIconImg: {
    verticalAlign: 'middle',
    maxHeight: '16px',
    maxWidth: '16px'
  },
  controlWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  exampleToggle: {
    display: 'inline-block',
    marginBottom: '10px',
    marginRight: '30px'
  },
  selectionDetails: {
    marginBottom: '20px'
  }
});